var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-sm-12 col-md-12 col-lg-12 text-center"},[_c('div',{staticClass:"notfound-css"},[_c('h1',[_vm._v("404")]),_c('p',[_vm._v("PÁGINA NÃO ENCONTRADA")])])])
}]

export { render, staticRenderFns }